import fetch from '@api/fetchers';

export const postPopupViewed = async (goalUID) => {
  try {
    await fetch('v1/user/DO4H1VZTYK/trial/expiry-pop-up/', {
      requestType: 'post',
      body: { goal_uid: goalUID }
    });
    // eslint-disable-next-line no-empty
  } catch {}
};

export const activateFreeTrial = async (goalUID) => {
  try {
    const data = await fetch('v2/subscriptions/trial/grant/', {
      requestType: 'post',
      body: {
        goal: goalUID,
        referral_code: 'FTWEB10'
      }
    });
    return data;
    // eslint-disable-next-line no-empty
  } catch {}
};
